import { render, staticRenderFns } from "./CRRNFDTabV2.vue?vue&type=template&id=8bb97b58&"
import script from "./CRRNFDTabV2.vue?vue&type=script&lang=ts&"
export * from "./CRRNFDTabV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports